import { FC, PropsWithChildren, useEffect } from 'react';
import { STOInsightsCoreContext } from 'modules/intelligentInsights/stoInsights/contexts/CoreContext';
import { TimespanEnum } from 'modules/intelligentInsights/types';
import { useLazyGraphql } from 'utils/hooks/useLazyGraphql';
import { isEmpty } from 'lodash';
import {
  fetchSTOReporting,
  STOReportingQueryResponse,
} from 'modules/intelligentInsights/stoInsights/graphql/fetchSTOReporting';
import { createCoreFetchVars } from 'modules/intelligentInsights/domain.utils';
import { useSTOInsightsSearchParams } from 'modules/intelligentInsights/stoInsights/hooks/useSTOInsightsSearchParams';

export const CoreContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { selectedTab, setSelectedTab } = useSTOInsightsSearchParams();

  const { fetch, isLoading, error, data, errorMessage } = useLazyGraphql<STOReportingQueryResponse>(
    fetchSTOReporting,
    {
      notifyOnNetworkStatusChange: true,
    },
  );

  useEffect(() => {
    fetch(createCoreFetchVars(TimespanEnum.Thirty));
  }, []);

  const dataLoaded = !isEmpty(data);
  let isReady = false;
  isReady = !isLoading && !error && dataLoaded;

  return (
    <STOInsightsCoreContext.Provider
      value={{
        isLoading,
        insightsData: data?.sendTimeOptimizationInsights ?? null,
        insightsErrorMessage: errorMessage ?? null,
        isError: !!error,
        isReady,
        fetchCoreData: (nextTimespan: TimespanEnum) => fetch(createCoreFetchVars(nextTimespan)),
        selectedMedium: selectedTab,
        setSelectedMedium: (value) => {
          setSelectedTab(value);
        },
      }}
    >
      {children}
    </STOInsightsCoreContext.Provider>
  );
};
